<template>
  <v-file-input
    v-bind="$attrs"
    v-on="$listeners"
    outlined
    multiple
    chips
    label="Select your files"
    prepend-icon=""
    prepend-inner-icon="mdi-paperclip"
  />
</template>

<script>
const AdsFileInput = {
  name: "AdsFileInput",
};

export default AdsFileInput;
</script>

<style lang='scss' scoped>
@import "../../styles/variables.scss";

::v-deep .theme--light.v-chip:not(.v-chip--active) {
  background: $ads-blue-2;
}

::v-deep .v-chip.v-size--default {
  border-radius: 4px;
}

::v-deep .theme--light.v-chip {
  color: $ads-white;
}
</style>
